module.exports = __webpack_public_path__ + "img/Shirt_sign.272e6f3a.jpg";